import type {TimeoutImplementationType} from "@cm/utils"

export const TimeoutImplementation: TimeoutImplementationType<ReturnType<typeof setTimeout>> = {
    setTimeout: (handler: () => void, delay: number) => setTimeout(handler, delay),
    clearTimeout: (id) => clearTimeout(id),
}
